import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { DateFormatter } from '../utils/DateFormatter'
import { NumberFormatter } from '../utils/NumberFormatter'
import InvoiceFinalInvoice from './InvoiceFinalInvoice'
import Context from '../context/Context'
import { InvoiceTypes } from '../helpers/Constants'

const InvoicePeriodText = ({ invoiceTypeId, invoice }) => {
  return (
    <div className="row mt-3">
      <div className="col-10 offset-1 text-center">
        {invoiceTypeId === InvoiceTypes.GROUP
          ? <div><span className="paragraph-regular-18">Här är din samlingsfaktura för perioden</span><br /></div>
          : <div><span className="paragraph-regular-18">Här är din faktura för perioden</span><br /></div>
        }
        <span className="paragraph-bold-18">
          {invoice.invoice_period_start}
        </span>
        <span className="paragraph-regular-18"> till </span>
        <span className="paragraph-bold-18">
          {invoice.invoice_period_end}
        </span>
      </div>
    </div>
  )
}

const ConsumptionText = ({ invoice }) => {
  return (
    <div className="row mt-2">
      <div className="col-10 offset-1 text-center">
        <span className="paragraph-regular-18">
          Under {DateFormatter.getMonthName(invoice.invoiced_month)} har du förbrukat <span className="thousandSeparator">{NumberFormatter.round(invoice.consumption)}</span> kWh.
        </span>
      </div>
    </div>
  )
}

const ProductionText = ({ invoice }) => {
  return (
    <div className="row mt-2">
      <div className="col-10 offset-1 text-center">
        <span className="paragraph-regular-18">
          Under {DateFormatter.getMonthName(invoice.invoiced_month)} har du producerat <span className="thousandSeparator">{NumberFormatter.round(Math.abs(invoice.consumption))}</span> kWh.
        </span>
      </div>
    </div>
  )
}

const DueDateText = ({ invoice }) => {
  return (
    <div className="row mt-4">
      <div className="col-10 offset-1 text-center">
        <span className="paragraph-regular-14">
          Oss tillhanda senast {DateFormatter.formatMonth(invoice.due_date)}
        </span>
      </div>
    </div>
  )
}

const PaymentInfoInvoice = () => {
  const context = useContext(Context)

  if (context.invoice.is_out_invoice === '1') {
    return (
      <div>
        <InvoicePeriodText invoiceTypeId={context.invoice_type_id} invoice={context.invoice} />
        {context.invoice.remaining_amount !== '0'
          ? <DueDateText invoice={context.invoice} />
          : null
        }
      </div>
    )
  }

  if (parseInt(context.invoice.invoice_type_id) === InvoiceTypes.FINAL) {
    return (
      <div>
        <InvoiceFinalInvoice />
        {context.invoice.remaining_amount !== '0'
          ? <DueDateText invoice={context.invoice} />
          : null
        }
      </div>
    )
  }

  if (parseInt(context.invoice.invoice_type_id) === InvoiceTypes.GROUP) {
    return (
      <div>
        <InvoicePeriodText invoiceTypeId={context.invoice_type_id} invoice={context.invoice} />
        {context.invoice.remaining_amount !== '0'
          ? <DueDateText invoice={context.invoice} />
          : null
        }
      </div>
    )
  }

  // Regular invoice
  return (
    <div>
      <InvoicePeriodText invoiceTypeId={context.invoice_type_id} invoice={context.invoice} />
      {context.invoice.is_production_site === '1'
        ? <ProductionText invoice={context.invoice} />
        : <ConsumptionText invoice={context.invoice} />
      }
      <div className="row mt-4">
        <div className="col-12 text-center">
          {context.invoice.remaining_amount !== '0'
            ? <DueDateText invoice={context.invoice} />
            : null
          }
        </div>
      </div>
    </div>
  )
}

InvoicePeriodText.propTypes = {
  invoiceTypeId: PropTypes.string,
  invoice: PropTypes.object
}

ConsumptionText.propTypes = {
  invoice: PropTypes.object
}

ProductionText.propTypes = {
  invoice: PropTypes.object
}

DueDateText.propTypes = {
  invoice: PropTypes.object
}

export default PaymentInfoInvoice
